import { configureStore } from "@reduxjs/toolkit";

import accountSlice from "../features/account/accountSlice";
import announcementSlice from "../features/announcement/announcementSlice";
import AssetsSlice from "../features/assets/assetsSlice";
import attendanceReducer from "../features/attendance/attendanceSlice";
import awardSlice from "../features/award/awardSlice";
import awardHistorySlice from "../features/awardHistory/awardHistorySlice";
import contractDetailSlice from "../features/contactDetail/contractDetailSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import dayPartSlice from "../features/dayPartSchedule/dayPartSlice";
import designationReducer from "../features/designation/designationSlice";
import documentSlice from "../features/document/documentSlice";
import emailConfigurationSlice from "../features/emailConfiguration/emailConfigSlice";
import employmentStatusSlice from "../features/employemntStatus/employmentStatusSlice";
import expenseSlice from "../features/expense/expenseSlice";
import expenseProjectSlice from "../features/expenseProject/expenseProjectSlice";
import leaveSlice from "../features/leave/leaveSlice";
import leavePolicySlice from "../features/leavePolicy/leavePolicySlice";
import linkUserSlice from "../features/linkUser/linkUserSlice";
import loanSlice from "../features/loan/loanSlice";
import approveReasonSlice from "../features/masters/approveReasonSlice";
import categorySlice from "../features/masters/categorySlice";
import contractTypeSlice from "../features/masters/contractTypeSlice";
import countrySlice from "../features/masters/countrySlice";
import currencySlice from "../features/masters/currencySlice";
import documentTypeSlice from "../features/masters/documentTypeSlice";
import genderSlice from "../features/masters/genderSlice";
import issueCountrySlice from "../features/masters/issueCountrySlice";
import lunchHoursSlice from "../features/masters/lunchHoursSlice";
import noticePeriodSlice from "../features/masters/noticePeriodSlice";
import payBySlice from "../features/masters/payBySlice";
import paymentTypeSlice from "../features/masters/paymentTypeSlice";
import rateSlice from "../features/masters/rateSlice";
import rejectReasonSlice from "../features/masters/rejectReasonSlice";
import relationShipSlice from "../features/masters/relationShipSlice";
import salutationSlice from "../features/masters/salutationSlice";
import stateSlice from "../features/masters/stateSlice";
import subCategorySlice from "../features/masters/subCategorySlice";
import teamsTypeSlice from "../features/masters/teamsTypeSlice";
import terminationReasonSlice from "../features/masters/terminationReasonSlice";
import workPlaceSlice from "../features/masters/workPlaceSlice";
import overtimeSlice from "../features/overtime/overtimeSlice";
import paymentSlice from "../features/payment/paymentSlice";
import payrollSlice from "../features/payroll/payrollSlice";
import AssignedTaskSlice from "../features/projectManagement/project/assignedTask/assignedTask";
import milestoneSlice from "../features/projectManagement/project/milestone/milestone";
import projectSlice from "../features/projectManagement/project/project/project";
import projectTaskSlice from "../features/projectManagement/project/projectTask/projectTask";
import projectTeamSlice from "../features/projectManagement/project/projectTeam/projectTeam";
import taskDependencySlice from "../features/projectManagement/project/taskDependency/taskDependency";
import taskPrioritySlice from "../features/projectManagement/project/taskPriority/taskPriority";
import taskStatusSlice from "../features/projectManagement/project/taskStatus/taskStatus";
import taskTimeSlice from "../features/projectManagement/project/taskTime/taskTime";
import publicHolidaySlice from "../features/publicHoliday/publicHolidaySlice";
import salaryComponentsSlice from "../features/salaryComponent/salaryComponentSlice";
import setUpSlice from "../features/setUp/setUpSlice";
import shiftSlice from "../features/shift/shiftSlice";
import terminationSlice from "../features/termination/terminationSlice";
import transactionSlice from "../features/transaction/transactionSlice";
import userReducer from "../features/user/userSlice";
import weeklyHolidaySlice from "../features/weeklyHoliday/weeklyHolidaySlice";
import loanRequestSlice from "../features/loanRequest/loanRequestSlice";
const reduxLogger = require("redux-logger");
const logger = reduxLogger.createLogger();

const store = configureStore({
	reducer: {
		users: userReducer,
		dashboard: dashboardReducer,
		designations: designationReducer,
		payroll: payrollSlice,
		payment: paymentSlice,
		shift: shiftSlice,
		employmentStatus: employmentStatusSlice,
		attendance: attendanceReducer,
		leave: leaveSlice,
		expense: expenseSlice,
		accounts: accountSlice,
		transactions: transactionSlice,
		announcement: announcementSlice,
		award: awardSlice,
		awardHistory: awardHistorySlice,
		leavePolicy: leavePolicySlice,
		weeklyHoliday: weeklyHolidaySlice,
		publicHoliday: publicHolidaySlice,
		milestone: milestoneSlice,
		project: projectSlice,
		projectTask: projectTaskSlice,
		projectTeam: projectTeamSlice,
		taskDependency: taskDependencySlice,
		taskStatus: taskStatusSlice,
		taskTime: taskTimeSlice,
		taskPriority: taskPrioritySlice,
		salaryComponents: salaryComponentsSlice,
		linkUser: linkUserSlice,
		document: documentSlice,
		AssignedTask: AssignedTaskSlice,
		asset: AssetsSlice,
		setUp: setUpSlice,
		dayPart :dayPartSlice,
		category: categorySlice,
		subCategory: subCategorySlice,
		state: stateSlice,
		country: countrySlice,
		currency: currencySlice,
		documentType: documentTypeSlice,
		rate: rateSlice,
		payBy: payBySlice,
		approveReason: approveReasonSlice,
		rejectReason: rejectReasonSlice,
		noticePeriod: noticePeriodSlice,
		terminationReason: terminationReasonSlice,
		gender: genderSlice,
		salutation: salutationSlice,
		relationShip: relationShipSlice,
		workPlace: workPlaceSlice,
		contractType: contractTypeSlice,
		teamsType: teamsTypeSlice,
		issueCountry: issueCountrySlice,
		paymentType: paymentTypeSlice,
		overtime: overtimeSlice,
		termination: terminationSlice,
		lunchHours: lunchHoursSlice,
		contractDetail: contractDetailSlice,
		loan: loanSlice,
		loanRequest: loanRequestSlice,
		emailConfiguration: emailConfigurationSlice,
		expenseProject: expenseProjectSlice,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
	// middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

export default store;
